const widgetName = 'socialNetworkWidget';
const instaWidgetcont = 'socialNetworkInstaFeed';
let initialized = false;

function initialize() {
  $(`#${widgetName}`).append('<div class="socialTabContainer" role="tablist"></div>');

  $(`#${widgetName}`).on('click keydown', '.socialNetworkTab', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      const tab = $(this).attr('data-social-network-tab');

      $('.socialNetworkTab').removeClass('activeTab');
      $('.socialNetworkTab').attr('aria-selected', false);
      $('.socialFeedContainer').hide();

      $(this).addClass('activeTab');
      $(this).attr('aria-selected', true);
      $(`#${tab}Container`).show();
    }
  });

  initialized = true;
}

function isCurrent(current, widget) {
  if (current) {
    $(`#${widgetName} #${widget}Tab`).addClass('activeTab');
    $(`#${widgetName} #${widget}Tab`).attr('aria-selected', true);
    $(`#${widgetName} #${widget}Container`).show();
  }
}

// FACEBOOK -----------

function facebookfeed(current) {
  const fbPageURL = 'https://www.facebook.com/MontanaFair/';
  const fbHeight = 500;
  const fbWidth = 500;

  const facebookfeedTab = `
    <a id="facebookfeedTab" class="socialNetworkTab" data-social-network-tab="facebookfeed"  role="tab" aria-selected="false" aria-controls="facebookfeedContainer" tabindex="0">      
      <svg viewBox="0 0 800 800"><title>Facebook Tab Icon</title><g id="Facebook_Tab_Icon" data-name="Facebook_Tab_Icon"><path class="circle" d="M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM509.06,259.72l-39.54,0c-31,0-37,14.73-37,36.35v47.67h73.93l-9.63,74.66H432.52V610h-77.1V418.42H290.94V343.76h64.47V288.69c0-63.9,39-98.69,96-98.69,27.3,0,50.77,2,57.61,2.94Z"/></g></svg>
    </a>
  `;
  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" style="display: none;" role="tabpanel" aria-labelledby="facebookfeedTab">
      <div class="fb-page" data-href="${fbPageURL}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbPageURL}"><a href="${fbPageURL}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;

  if (!initialized) {
    initialize();
  }

  $(`#${widgetName} .socialTabContainer`).append(facebookfeedTab);
  $(`#${widgetName}`).append(facebookfeedContainer);

  isCurrent(current, 'facebookfeed');
}

// INSTAGRAM -----------

function instafeed(current) {
  const instafeedContainer =
    '<div id="instafeedContainer" class="socialFeedContainer" style="display: none;" role="tabpanel"></div>';

  if (!initialized) {
    initialize();
  }

  // $(`#${instaWidgetcont} .socialTabContainer`).append(instafeedTab);
  $(`#${instaWidgetcont}`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer',
  });
  feed.run();

  isCurrent(current, 'instafeed');

  // shorten alt text
  $(window).load(function () {
    const maxLength = 95;
    $('#instafeedContainer img').each(function () {
      const caption = $(this).attr('alt').trim();
      if (caption.length > maxLength) {
        $(this).attr('alt', caption.substring(0, maxLength) + '...');
      }
    });
  });
}

export { facebookfeed, instafeed };
